<template>
<div class="modal is-large is-active">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <div class="default-settings-title">
                <span class="account-name">Change Database Storage</span>
                <span class="default-settings-subtitle">Change the storage of the database.</span>
            </div>

            <div class="backup" style="margin-bottom: 35px;">
                <div class="columns is-multiline">
                    <div class="column is-full" style="margin-top:-10px;">
                        <div class="notification is-default" style="font-size:13px;">
                            Weap.io will use this storage to store the future backups of this database. The already existent backups will not be affected by this change and will remain on their storage.
                        </div>
                    </div>

                    <div class="column is-6">
                        <div class="field">
                            <div class="control has-icons-left">
                                <div class="select is-fullwidth">
                                    <select v-model="selectedStorage">
                                        <option v-for="storage in storages" v-bind:key="storage.id" :value="storage.id">{{ storage.name + ' (' + storage.provider + ')' }}</option>
                                    </select>
                                </div>
                                <div class="icon is-left is-custom-icon-left">
                                    <font-awesome-icon icon="hdd"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns is-multiline" style="margin-top: 10px;">
                <div class="column is-3">
                    <div @click="changeStorage" :disabled="changingStorage" :class="{ 'is-loading': changingStorage }" class="button custom-button-size is-fullwidth is-info">Change Storage</div>
                </div>
                <div class="column is-3">
                    <div @click="close" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger" :disabled="changingStorage">Cancel</div>
                </div>
            </div>
        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';

export default {
    props: ['database'],

    data() {
        return {
            storages: [],
            selectedStorage: null,
            changingStorage: false,

            // active: false,
            // name: '',
            // token: '',
            // providerSlug: 'digital_ocean',
            // creatingAccount: false,
        }
    },

    mounted() {
        this.getStorages();
        this.listenEvents();
    },

    methods: {
        close() {
            if (!this.creatingStorage) {
                Event.$emit('changeDatabaseStorageModalClosed');
            }
        },

        getStorages() {
            Api().get('users/current/storages')
                .then((success) => {
                    this.storages = success.data.data;
                    for (var i = 0; i <= this.storages.length; i++) {
                        if (this.storages[i].id == this.database.storage.id) {
                            this.selectedStorage = this.storages[i].id;
                        }
                    }
                });
        },

        changeStorage() {
            if (this.changingStorage) {
                return;
            }
            
            this.changingStorage = true;

            var databaseStorage = {
                storage_id: this.selectedStorage,
            };

            Api().put('databases/' + this.database.id + '/storage', databaseStorage)
                .then((success) => {
                    Event.$emit('databaseStorageChanged', () => {
                        swal('Success!', 'The database storage was changed successfully.', 'success');
                    });
                })
                .catch((error) => {
                    if (error.response.status == 409) {
                        Event.$emit('databaseStorageChanged', () => {

                            Swal.fire({
                                title: 'Oops',
                                text: 'The last backup of this database is still pending or in progress. Wait until it\'s done before changing the database storage.',
                                type: 'error',
                            });
                        });
                    }
                })
                .finally(() => {
                    this.changingStorage = false;
                });
        },

        listenEvents() {
            //
        },
    },
}
</script>
